import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { Order } from '../../models/Order';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';

export const { mapFields: mapOrderFields } = createHelpers({
  getterType: `orders/getField`,
  mutationType: `orders/updateField`,
});

export const { mapMultiRowFields: mapOrderMultiRowFields } = createHelpers({
  getterType: `orders/getField`,
  mutationType: `orders/updateField`,
});

//import order from './forms/order';
import auth from './forms/auth';
import customer from './forms/customer';
import dealer from './forms/dealer';
import employee from './forms/employee';
import company from './forms/company';
import newChurn from './forms/NewChurn';
import landline from './forms/Landline';
import address from './forms/address';
import ratePlan from './forms/ratePlan';
import summary from './forms/summary';
import internet from './forms/Internet';
import isdn from './forms/NewISDN';
import pstn from './forms/NewPSTN';
import ipVoice from './forms/IPVoice';
import notes from './forms/note';
import hardware from './forms/hardware';
import handset from './forms/handset';
import termsConditions from './forms/termsConditions';
import porting from './forms/porting';
import uploads from './forms/uploads';
import { DirectDebit } from '../../models/DirectDebit';
import financeApplication from './forms/financeApplication';
import Sip from './forms/sip';
import mobile from './forms/VonexMobile';
import inbound from './forms/Inbound';
import menu from './forms/menu';
import fax from './forms/fax';
import Cmc from './forms/Cmc';
import routes from './forms/vueRouter';
import dealerPortal from './forms/DealerPortal';
import audit from './forms/audit';
import relocation from './forms/relocation';
import changeLessee from './forms/changeLessee';
import utility from './forms/utility';
import notifications from './forms/notifications';
import qantas from './forms/qantas';
import customerDetail from './forms/customerDetail';
import wholesalerDetail from './forms/wholesalerDetail';
import featureFlag from './forms/featureFlag';
import commissionTargets from './forms/commissionTargets';

const actions = {
  getAuth({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('GetAuthorisation')
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting Auths:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  updateSignature({ commit, dispatch }, signature) {
    return new Promise((resolve, reject) => {
      let header = HTTP.defaults.headers.common.Authorization;
      delete HTTP.defaults.headers.common.Authorization;
      var response = HTTP.post('/Order/addSignature/', signature);
      response
        .then(function(data) {
          HTTP.defaults.headers.common.Authorization = header;
          var resultData = data.data;
          commit('setSignature', signature.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Updated OK',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getDealerFromEmail({ commit, state }) {
    return new Promise((resolve, reject) => {
      HTTP.post('Order/getDealerFromEmail', {
        email: 'guest',
      })
        .then(data => {
          commit('orders/dealer/setDealer', data.data, {
            root: true,
          });
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  reprocessOrder({ commit, dispatch, state }, envelopeID) {
    commit('setReprocessOrderDialog', true);

    setTimeout(function() {
      return new Promise((resolve, reject) => {
        HTTP.post(`Docusign/reprocess/${envelopeID}`)
          .then(function(data) {
            if (data.status == 200) {
              commit('setReprocessOrderDialog', false);
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Order has been reprocessed!',
                  httpStatus: 200,
                })
              );
              resolve(data.data);
            } else reject('Unable to reprocess order!');
          })
          .catch(err => {
            commit('setReprocessOrderDialog', false);
            dispatch(
              'setMessage',
              new httpError({
                message: 'Error in reprocessing order : ' + err.message,
                httpStatus: 500,
              })
            );
            reject(err);
          });
      });
    }, 500);
  },

  getContacts({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      HTTP.get('order/GetContacts/' + orderID)
        .then(function(data) {
          if (data.status == 200) {
            commit('setOrderContacts', data.data);
            commit(
              'setProgress',
              new httpError({
                message: 'Contacts Retrieved',
                httpStatus: 200,
              })
            );
            resolve(data.data);
          } else reject('No Content');
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error in retrieving Contacts : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeContact({ commit, dispatch, rootState }, contact) {
    return new Promise((resolve, reject) => {
      HTTP.delete(
        'order/DeleteContactsFromOrder/' + rootState.orders.rows[0].orderID,
        {
          data: [contact],
        }
      )
        .then(() => {
          commit('removeContact', contact);
          resolve();
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  saveContact({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post(`order/AddOrderContact/${data.orderID}`, data.contact)
        .then(data => {
          commit('setOrderContacts', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Saved OK',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  resetOrder({ commit, dispatch }) {
    return new Promise(resolve => {
      dispatch('menu/reset');
      dispatch('customer/resetCustomer');
      dispatch('newChurn/resetNewChurn');
      dispatch('address/resetAddress');
      dispatch('company/resetCompany');
      dispatch('landline/resetLandline');
      dispatch('pstn/resetPstn');
      dispatch('isdn/resetISDN');
      dispatch('ipVoice/resetIPVoice');
      dispatch('summary/resetSummary');
      dispatch('notes/resetNotes');
      dispatch('ratePlan/getRatePlans');
      dispatch('internet/resetInternet');
      dispatch('hardware/reset');
      dispatch('termsConditions/reset');
      dispatch('porting/reset');
      dispatch('uploads/reset');
      dispatch('Sip/reset');
      dispatch('mobile/reset');
      dispatch('inbound/reset');
      dispatch('fax/reset');
      dispatch('Cmc/reset');
      dispatch('routes/reset');
      dispatch('financeApplication/reset');
      dispatch('relocation/reset');
      dispatch('changeLessee/reset');
      dispatch('utility/reset');
      dispatch('notifications/reset');
      dispatch('audit/reset');
      dispatch('setMessage', new httpError());

      commit('setOrder', new Order());
      resolve();
    });
  },
  getTrainingLinks({ dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetTrainingLinks/'); // 4 = cancelled
      response
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateOrderType({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.put('Order/UpdateOrderType/' + data.orderID + '/' + data.type)
        .then(function(data) {
          var resultData = data.data;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + data.orderID + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateOrder({ commit, dispatch }, order) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put('Order/UpdateOrder/' + order.orderID, order); // 4 = cancelled
      response
        .then(function(data) {
          var resultData = data.data;

          if (resultData.orderStatus == 4) {
            HTTP.put('Docusign/VoidDocusignEnvelope/' + order.orderID)
              .then(data => {
                resolve(resultData);
              })
              .catch(err => {
                reject(err);
              });
          }
          commit('setOrder', resultData);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order :' + order.orderID + ' has been updated.',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  removeOrder({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      if (orderID === 0) {
        reject('no orderID');
        return;
      }
      var response = HTTP.put('Order/CancelOrder/' + orderID);
      response
        .then(function(data) {
          var resultData = data.data;
          HTTP.put('Docusign/CancelOrderAndVoidDocusignEnvelope/' + orderID)
            .then(() => {
              commit('setOrder', resultData);
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Order :' + orderID + ' has been cancelled.',
                  httpStatus: 200,
                })
              );
              resolve(resultData);
            })
            .catch(err => {
              reject(err);
            });
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  addOrder({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.customerID === 0) {
        reject('no customerID');
        return;
      }
      var dealerID = rootState.orders.dealer.dealer.dealerID;
      var order = new Order();
      order.dealerID = dealerID;
      order.customerID = payload.customerID;
      order.orderType = payload.type;
      //order.existingCustomer = true;
      var response = HTTP.post('Order/CreateOrder', order);
      response
        .then(function(data) {
          if (data.status == 204) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Unable to create order',
                httpStatus: 500,
              })
            );
            return resolve();
          }

          var resultData = data.data;
          dispatch('resetOrder');
          commit('setOrder', resultData);
          commit('orders/customer/setCustomer', resultData.customerDetails, {
            root: true,
          });
          if (resultData.customerDetails !== null) {
            commit(
              'orders/address/setAddress',
              resultData.customerDetails.addressDetails[0],
              {
                root: true,
              }
            );
            commit(
              'orders/address/setAddresses',
              resultData.customerDetails.addressDetails,
              {
                root: true,
              }
            );
          }
          resolve(resultData);
          //dispatch("getOrder", resultData.orderID).then(data => {
          //   // dispatch('orders/address/getAddress', resultData.customerDetails.addressID, { root: true });
          //    resolve(resultData);
          //});
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listOrders({ dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetOrders/' + orderID);
      response
        .then(function(data) {
          var resultData = data.data;
          dispatch(
            'setMessage',
            new httpError({
              message: 'Orders retrieved ',
              httpStatus: 200,
            })
          );
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listAllOrders() {
    return new Promise((resolve, reject, dispatch) => {
      var response = HTTP.get('Order/GetAllOrders');
      response
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listInProgressOrders() {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetAllInProgressOrders');
      response
        .then(function(data) {
          var resultData = data.data;
          resolve(resultData);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async sendInProgressOrders({ dispatch }, email, time) {
    var response = await HTTP.post(
      'Order/SendReportOrdersInProgress',
      email,
      time
    );
    if (response.status == 200) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Message Sent',
          httpError: 200,
        })
      );
      return new Promise.resolve();
    }
  },
  async resubmitOrderToKayako({ dispatch }, orderID) {
    try {
      var data = await HTTP.post('Order/ResendToKayako/' + orderID);
      if (data.status == 200) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'resubmitted',
            httpError: 200,
          })
        );
        return new Promise.resolve();
      }
    } catch (error) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'not resubmitted: ' + error.message,
          httpError: 500,
        })
      );
      return new Promise.reject();
    }
  },
  async getOrder({ commit, dispatch }, orderID) {
    return new Promise((resolve, reject) => {
      dispatch('resetOrder');
      HTTP.get('Order/GetOrders/' + orderID)
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        })
        .then(data => {
          if (data.data) {
            let resultData = data.data[0];
            //commit("setOrder", resultData);
            commit('setOrder', resultData);
            dispatch('orders/menu/getStatus', null, {
              root: true,
            });
            commit('orders/customer/setCustomer', resultData.customerDetails, {
              root: true,
            });
            if (resultData.customerDetails.addressDetails.length > 0) {
              commit(
                'orders/address/setAddress',
                resultData.customerDetails.addressDetails[0],
                {
                  root: true,
                }
              );
              commit(
                'orders/address/setAddresses',
                resultData.customerDetails.addressDetails,
                {
                  root: true,
                }
              );
            }
            if (resultData.customerDetails.companyID > 0) {
              commit(
                'orders/company/setCompany',
                resultData.customerDetails.companyDetails,
                {
                  root: true,
                }
              );
            }
            dispatch('getContacts', orderID);
            dispatch('orders/uploads/populateUploads', orderID, {
              root: true,
            });

            dispatch(
              'setMessage',
              new httpError({
                message: 'Order retreived',
                httpStatus: 200,
              })
            );
            resolve(resultData);
          }
        });
    });
  },
  addLandline({ commit, state }, landline) {
    commit('setLandline', landline.landlineID);
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'Order/addLandlineOrder/' + state.rows[0].orderID,
        landline
      );
      response
        .then(function(data) {
          resolve(data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  getDirectDebit({ commit, state }) {
    return new Promise(resolve => {
      if (state.rows[0].directDebit == null)
        commit('setDirectDebit', new DirectDebit());

      resolve(state.rows[0].directDebit);
    });
  },
  updateDirectDebit({ commit, state, dispatch }, directDebit) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put(
        'Order/updateDirectDebit/' + state.rows[0].orderID,
        directDebit
      );
      response
        .then(data => {
          commit('setDirectDebit', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Direct Debit info updated',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  removeDirectDebit({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      commit('setDirectDebit', null);
      dispatch('updateDirectDebit')
        .then(() => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Direct Debit info updated',
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  voidEnvelope({}, order) {
    return new Promise((resolve, reject) => {
      if (order && order.orderID) {
        HTTP.put('Docusign/VoidDocusignEnvelope/' + order.orderID)
          .then(data => {
            resolve(data.data);
          })
          .catch(err => {
            reject(err);
          });
      }
    });
  },
  resetToEdit({ commit, dispatch, rootState }, orderID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.put('Order/resetOrderToEdit/' + orderID);
      response
        .then(data => {
          commit('setOrder', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Order reset for editing',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  sendSQRequest({ dispatch }, address) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/sendSQ', {
        address: address,
      });
      response
        .then(response => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Message sent',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
    // return new Promise((resolve, reject) => {
    //   var response = HTTP.post(
    //     "SQ/sendSQ/"  + rootState.orders.dealer.dealer.dealerID, address
    //   );
    //   response
    //   .then()
    //   .catch();
  },
  getAdminRows({ dispatch }) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get('Order/GetIPRowsByOrder/');
      response
        .then(response => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  updateAdminRows({ dispatch }, rows) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/UpdateRowsFromAdmin', rows);
      response
        .then(response => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  sendUpdatedMacs({ dispatch }, element) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Docusign/SendUpdatedMacAddress', element);
      response
        .then(response => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rows attained',
              httpStatus: 500,
            })
          );
          resolve(response.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error sending message ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  getBundles({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get('Order/GetBundles')
        .then(data => {
          if (data.data == '') {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Data not available',
                httpStatus: 204,
              })
            );
          } else {
            commit('setBundles', data.data);
            resolve(data.data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveNewBundle({}, bundle) {
    return new Promise((resolve, reject) => {
      HTTP.post('Order/SaveBundle', {
        bundleName: bundle,
      })
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateBundle({}, bundle) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        'Order/UpdateBundle',
        bundle
        //{
        //   id: bundle.id,
        //   bundleId: bundle.bundleId,
        //   ratePlanId: bundle.ratePlanId,
        //   detail: bundle.detail,
        //   contractMonths: bundle.contractMonths,
        //   usageType: bundle.usageType,
        //   handsetId: bundle.handsetId,
        //   rrpInc: bundle.rrpInc,
        //   bundleName: bundle.bundleName,
        //   excludeFromTCV: bundle.excludeFromTCV,
        // }
      )
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateServiceLevelOnBundle({}, bundle) {
    return new Promise((resolve, reject) => {
      HTTP.post('Order/UpdateServiceLevelOnBundle', bundle)
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteBundle({}, id) {
    // to be confirm
    return new Promise((resolve, reject) => {
      HTTP.delete(`Order/DeleteBundle/${id}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  async getHardwareOrders({ commit, state }) {
    try {
      // var result = await HTTP.post("Mia/GetAllOrders", state.pagination);
      var result = await HTTP.post('Mia/GetAllOrders');
      commit('setHardwareOrders', result.data);
      commit('setTableLoading');
      //commit("nextPage");
      return Promise.resolve(result.data);
    } catch (e) {
      commit('setTableLoading');
      return Promise.reject(e);
    }
  },
  async processOrdersWith5G({}, args) {
    try {
      const result = await HTTP.post(`Order/ProcessOrderWith5G/`, args);
      return Promise.resolve(result.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getOrdersWith5G({}) {
    try {
      const result = await HTTP.get('Order/GetOrdersWith5G');
      return Promise.resolve(result.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async check5GOrderStatus({}, params) {
    try {
      const result = await HTTP.get(`Order/ServiceInquiry/${params}`);
      return Promise.resolve(result.data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  async getOrderSummary({}, orderID) {
    try {
      var result = await HTTP.get(`Order/GetFilesOnOrder/${orderID}`);
      var attachment = result.data.filter(x => x.filename === `${orderID}.pdf`);
      var response = await HTTP.post(
        `Order/GetAttachment/${orderID}`,
        { filename: attachment[0].filename },
        {
          responseType: 'blob',
        }
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: attachment[0].contentType })
      );
      window.open(url, '_blank');
    } catch (e) {
      return Promise.reject(e);
    }
  },
  resetCurrentPage({ commit }) {
    commit('resetPage');
  },

  async getHardwareDetails({ commit, dispatch }, item) {
    commit('setSelectedOrder', item);
    return new Promise((resolve, reject) => {
      HTTP.get(`Mia/GetOrderHardwareDetail/${item.orderID}`)
        .then(result => {
          if (result.status !== 204) {
            commit('setHardwareDetails', result.data);
            commit('setCurrentOrder', result.data);
          }
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  setInventoryDetails({ commit }, item) {
    commit('setInventoryDetails', item);
  },
  resetHardwareDetails({ commit }) {
    commit('resetHardwareDetails');
  },
  async getAllStock({ commit }) {
    try {
      var result = await HTTP.get('Mia/GetAllStocksOnHand');
      if (result.data.stocks)
        result.data.stocks.forEach(element => {
          element.internalID = element[' InternalID'];
          element['On Hand Qty'] = parseInt(element['On Hand Qty']);
          delete element[' InternalID'];
        });
      commit('setAllStocks', result.data.stocks);
    } catch (e) {
      return Promise.reject(e);
    }
  },

  async sendMIAOrder({ state }, itemDetails) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Mia/SendOrder/${state.selectedOrder.orderID}`, itemDetails)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async saveOrderElsewhere({ state }, items) {
    return new Promise((resolve, reject) => {
      HTTP.post(`Mia/SaveOrderElsewhere/${state.selectedOrder.orderID}`, items)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  async sellInOrderService({ state }, orderID) {
    return new Promise((resolve, reject) => {
      HTTP.post(`BulkUpload/bulkUploadOrderServices/${orderID}`)
        .then(data => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDeliveryDetails({ dispatch, commit, rootState }, orderID) {
    return new Promise((resolve, reject) => {
      var response = HTTP.get(`Mia/getDeliveryDetails/${orderID}`);
      response
        .then(function(data) {
          var resultData = data.data;
          let details = {
            contactName: resultData.hardwareOrder.contactName,
            deliveryInstructions: resultData.hardwareOrder.deliveryInstructions,
            contactDetails: {
              contactEmail: resultData.hardwareOrder.contactEmail,
              contactMobile: resultData.hardwareOrder.contactMobile,
              contactName: resultData.hardwareOrder.contactName,
              contactID: resultData.hardwareOrder.contactID,
              companyName: resultData.company.companyName,
            },
            hardwareOrder: resultData.hardwareOrder,
            company: resultData.company,
          };
          if (resultData.addresses[0]) {
            let address = resultData.addresses.filter(
              _address =>
                _address.addressID === resultData.hardwareOrder.addressID
            );
            details.address = address[0].formattedAddress;
            details.addressDetails = address[0];
          } else {
            dispatch(
              'orders/address/getAllAddresses',
              resultData.customer.customerID,
              { root: true }
            );

            let addresses = rootState.orders.address.addresses;
            details.address = addresses[0].formattedAddress;
            details.addressDetails = addresses[0];
          }
          commit('setDeliveryDetails', details);
          resolve(details);
        })
        .catch(err => {
          commit('setDeliveryDetails', {});
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error: ' + err.message,
              httpStatus: 500,
            })
          );
          return resolve(err);
        });
    });
  },
  async getKayakoNotes({ dispatch }, conversationId) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.get(`Order/GetKayakoNotes/${conversationId}`);
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  async deleteKayakoNote({ dispatch }, note) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.delete(`Order/DeleteKayakoNote`, {
          data: {
            noteUrl: note.noteUrl,
            id: note.id,
            text: note.text,
            conversationId: note.conversationId,
          },
        });
        if (response.status !== 200) resolve(response);
        var result = response;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
};

const mutations = {
  setIPOrder(state, ipOrderID) {
    state.rows[0].ipOrderID = ipOrderID;
  },
  setOrder(state, order) {
    if (typeof order !== 'undefined') state.rows.splice(0, 1, order);
  },
  setOrderType(state, type) {
    state.rows[0].orderType = type;
  },
  setOrderTicket(state, ticket) {
    state.rows[0].kayakoConversation = ticket;
  },
  setOrderEnvelope(state, envelopeID) {
    state.rows[0].docuSignEnvelopeID = envelopeID;
  },
  setOrderStatus(state, status) {
    state.rows[0].orderStatus = status;
  },
  setProgress(state, message) {
    state.message = message;
  },
  setLandline(state, landlineID) {
    state.rows[0].landlineID = landlineID;
  },
  setSignature(state, signature) {
    state.rows[0].signature = signature;
    state.rows[0].orderStatus = 2;
  },
  setResidential(state, flag) {
    state.isResidential = flag;
  },
  setHardware(state, hardwareID) {
    state.rows[0].hardwareID = hardwareID;
  },
  setDirectDebit(state, directDebit) {
    state.rows[0].directDebit = directDebit;
  },
  setExistingCust(state) {
    state.rows[0].existingCustomer = true;
  },
  setOrderContacts(state, contacts) {
    state.rows[0].contacts = contacts;
  },
  removeContact(state, contact) {
    state.rows[0].contacts.splice(state.rows[0].contacts.indexOf(contact), 1);
  },
  setReprocessOrderDialog(state, status) {
    state.reprocessOrderDialog = status;
  },
  updateField,
  setBundles(state, bundles) {
    state.bundles = bundles;
  },
  setHardwareOrders(state, result) {
    if (result !== null || result !== 0 || result !== '')
      state.hardwareOrders = [...result];
  },
  setTableLoading(state) {
    state.tableLoading = false;
  },
  nextPage(state) {
    state.pagination.currentPage += 1;
    state.pagination.pageSize += 25;
  },
  resetPage(state) {
    state.pagination.currentPage = 0;
    state.pagination.pageSize = 25;
  },
  setHardwareDetails(state, result) {
    result.forEach(x => {
      x.status = state.selectedOrder.status;
      if (!x.itemName) {
        let items = state.allStocks.filter(
          row => row.internalID === x.itemInternalID
        );
        x.itemName = items[0]['Store Display Name'];
      }
    });
    state.hardwareDetails = result;
  },
  setInventoryDetails(state, item) {
    let tempInventoryDetails = [];
    item.forEach(itemDetail => {
      let product = itemDetail.itemName;
      let status = itemDetail.status;
      if (itemDetail.inventoryDetails) {
        let detail = itemDetail.inventoryDetails.map(macs => {
          macs.product = product;
          macs.status = status;
          return macs;
        });
        tempInventoryDetails.push(detail);
      }
    });
    state.inventoryDetails = tempInventoryDetails.flat();
  },
  resetHardwareDetails(state) {
    state.hardwareDetails = [];
    state.inventoryDetails = [];
  },
  setSelectedOrder(state, item) {
    state.selectedOrder = item;
  },
  setAllStocks(state, item) {
    state.allStocks = item;
  },
  setCurrentOrder(state, result) {
    state.currentOrder = result;
  },
  setDeliveryDetails(state, data) {
    state.deliveryDetails = data;
  },
};

const getters = {
  totalCost: rootState => {
    let result = rootState.ipVoice.rows
      .map(x =>
        rootState.ipVoice.handsets
          .filter(y => y.handsetID == x.handsetID)
          .reduce((a, c) => parseFloat(c.rrpEx * 1.1) + a, 0.0)
      )
      .reduce((a, c) => parseFloat(a + c), 0.0);

    let rowCount = rootState.ipVoice.rows
      .map(x =>
        rootState.ipVoice.handsets
          .filter(y => y.handsetID == x.handsetID)
          .reduce((a, c) => (parseFloat(c.rrpEx) > 0 ? 1 : 0) + a, 0.0)
      )
      .reduce((a, c) => parseFloat(a + c), 0.0);
    let freight = rowCount == 0 ? 0.0 : (rowCount - 1) * 7.5 + 20.0;
    return result + freight;
  },
  isLoggedIn: state => state.auth.isAuthenticated,
  hasOrder: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated && state.rows[0].orderID > 0,
  hasSignature: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated && state.rows[0].signature,
  hasDealer: (state, rootState) =>
    state.auth.isAuthenticated &&
    state.dealer.dealer &&
    state.dealer.dealer.dealerID > 0,
  isAdmin: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated &&
    rootGetters['orders/authGroup'] == 'Administrators' &&
    rootGetters['orders/authLevel'] == 'Admin',
  authGroup: state => state.dealer.dealer.authGroup,
  authLevel: state => state.dealer.dealer.authLevel,
  hasAddress: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated && state.address.address.addressID > 0,
  hasCustomer: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated && state.customer.customer !== null,
  isSigned: (state, getters, rootState, rootGetters) =>
    state.auth.isAuthenticated && state.rows[0].orderStatus > 0,
  // isExistingCustomer: state => state.rows[0].existingCustomer, //remap to ubaccountno
  isExistingCustomer: state =>
    state.rows &&
    state.rows[0] &&
    state.rows[0].customerDetails &&
    state.rows[0].customerDetails.ubAccountNo !== 0
      ? true
      : false,
  isResidential: state =>
    state.customer.customer && state.customer.customer.companyDetails == null,
  isChangeOfAddress: state => state.rows[0].orderType === 1,
  isChangeOfLessee: state => state.rows[0].orderType === 2,
  isQantas: state => state.rows[0].orderType === 3,
  isGrenke: state => {
    if (state.ipVoice.rows.length == 0) return false;
    if (state.ipVoice.ratePlans.length == 0) return false;
    let plans = state.ipVoice.rows.map(x => x.ratePlanID);
    return state.ipVoice.ratePlans
      .filter(x => plans.includes(x.ratePlanID))
      .some(y => y.grenkeFinance === true);
  },
  hasIP: state => {
    if (state.ipVoice.iporder.orderID == 0) return false;
    // if (state.ipVoice.iporder.ipOrderID == 0) return false;
    if (state.ipVoice.ratePlans.length == 0) return false;
    let plans = state.ipVoice.rows.map(x => x.ratePlanID);
    return state.ipVoice.ratePlans
      .filter(x => plans.includes(x.ratePlanID))
      .some(y => y.usageType === 'VoIP');
  },
  orderID: state => state.rows[0].orderID,
  financeAllowed: (state, getters) => {
    return getters.isQantas && !getters.isExistingCustomer;
  },
  getField,
  reprocessOrderDialog: state => state.reprocessOrderDialog,
  bundles: state => state.bundles,
  hardwareOrders: state => {
    return state.hardwareOrders;
  },
  tableLoading: state => {
    return state.tableLoading;
  },
  hardwareDetails: state => {
    return state.hardwareDetails;
  },
  inventoryDetails: state => {
    return state.inventoryDetails;
  },
  selectedOrder: state => {
    return state.selectedOrder;
  },
  allStocks: state => {
    return state.allStocks;
  },
  currentOrder: state => {
    return state.currentOrder;
  },
  deliveryDetails: state => state.deliveryDetails,
};

const state = {
  rows: [new Order()],
  qantasOrder: false,
  message: new httpError(),
  reprocessOrderDialog: false,
  bundles: [],
  hardwareOrders: [],
  tableLoading: true,
  pagination: {
    pageSize: 25,
    currentPage: 0,
    orderBy: 'orderID',
  },
  hardwareDetails: [],
  inventoryDetails: [],
  selectedOrder: {},
  allStocks: [],
  currentOrder: {},
  deliveryDetails: {},
};

const modules = {
  // order, auth,
  auth,
  dealer,
  employee,
  address,
  company,
  customer,
  commissionTargets,
  newChurn,
  landline,
  ratePlan,
  summary,
  isdn,
  pstn,
  ipVoice,
  notes,
  internet,
  hardware,
  handset,
  termsConditions,
  porting,
  uploads,
  Sip,
  mobile,
  inbound,
  menu,
  fax,
  Cmc,
  routes,
  dealerPortal,
  financeApplication,
  relocation,
  changeLessee,
  utility,
  notifications,
  audit,
  qantas,
  customerDetail,
  wholesalerDetail,
  featureFlag,
};
export const {
  mapMultiRowFields: mapFinanceApplicationMultiRowFields,
} = createHelpers({
  getterType: 'orders/financeApplication/getField',
  mutationType: 'orders/financeApplication/updateField',
});
export const { mapFields: mapDealerPortalFields } = createHelpers({
  getterType: `orders/dealerPortal/getField`,
  mutationType: `orders/dealerPortal/updateField`,
});
export const {
  mapMultiRowFields: mapDealerPortalMultiRowFields,
} = createHelpers({
  getterType: 'orders/dealerPortal/getField',
  mutationType: 'orders/dealerPortal/updateField',
});

export const { mapFields: mapCustomerDetailFields } = createHelpers({
  getterType: `orders/customerDetail/getField`,
  mutationType: `orders/customerDetail/updateField`,
});
export const {
  mapMultiRowFields: mapCustomerDetailMultiRowFields,
} = createHelpers({
  getterType: 'orders/customerDetail/getField',
  mutationType: 'orders/customerDetail/updateField',
});

export const { mapFields: mapWholesalerDetailFields } = createHelpers({
  getterType: `orders/wholesalerDetail/getField`,
  mutationType: `orders/wholesalerDetail/updateField`,
});
export const {
  mapMultiRowFields: mapWholesalerDetailMultiRowFields,
} = createHelpers({
  getterType: 'orders/wholesalerDetail/getField',
  mutationType: 'orders/wholesalerDetail/updateField',
});

export const { mapFields: mapVueRoutesFields } = createHelpers({
  getterType: `orders/routes/getField`,
  mutationType: `orders/routes/updateField`,
});
export const { mapMultiRowFields: mapVueRoutesMultiRowFields } = createHelpers({
  getterType: 'orders/routes/getField',
  mutationType: 'orders/routes/updateField',
});

export const { mapFields: mapCmcFields } = createHelpers({
  getterType: `orders/Cmc/getField`,
  mutationType: `orders/Cmc/updateField`,
});
export const { mapMultiRowFields: mapCmcMultiRowFields } = createHelpers({
  getterType: 'orders/Cmc/getField',
  mutationType: 'orders/Cmc/updateField',
});

export const { mapFields: mapFaxFields } = createHelpers({
  getterType: `orders/fax/getField`,
  mutationType: `orders/fax/updateField`,
});
export const { mapMultiRowFields: mapFaxMultiRowFields } = createHelpers({
  getterType: 'orders/fax/getField',
  mutationType: 'orders/fax/updateField',
});

export const { mapFields: mapMenuFields } = createHelpers({
  getterType: `orders/menu/getField`,
  mutationType: `orders/menu/updateField`,
});
export const { mapMultiRowFields: mapMenuMultiRowFields } = createHelpers({
  getterType: 'orders/menu/getField',
  mutationType: 'orders/menu/updateField',
});

export const { mapFields: mapInboundFields } = createHelpers({
  getterType: `orders/inbound/getField`,
  mutationType: `orders/inbound/updateField`,
});
export const { mapMultiRowFields: mapInboundMultiRowFields } = createHelpers({
  getterType: 'orders/inbound/getField',
  mutationType: 'orders/inbound/updateField',
});

export const { mapFields: mapMobileFields } = createHelpers({
  getterType: `orders/mobile/getField`,
  mutationType: `orders/mobile/updateField`,
});
export const { mapMultiRowFields: mapMobileMultiRowFields } = createHelpers({
  getterType: 'orders/mobile/getField',
  mutationType: 'orders/mobile/updateField',
});

export const { mapFields: mapSipFields } = createHelpers({
  getterType: `orders/Sip/getField`,
  mutationType: `orders/Sip/updateField`,
});
export const { mapMultiRowFields: mapSipMultiRowFields } = createHelpers({
  getterType: 'orders/Sip/getField',
  mutationType: 'orders/Sip/updateField',
});

export const { mapFields: mapUploadFields } = createHelpers({
  getterType: `orders/uploads/getField`,
  mutationType: `orders/uploads/updateField`,
});
export const { mapMultiRowFields: mapUploadMultiRowFields } = createHelpers({
  getterType: 'orders/uploads/getField',
  mutationType: 'orders/uploads/updateField',
});

export const { mapFields: mapPortingFields } = createHelpers({
  getterType: `orders/porting/getField`,
  mutationType: `orders/porting/updateField`,
});

export const { mapMultiRowFields: mapPortingMultiRowFields } = createHelpers({
  getterType: 'orders/porting/getField',
  mutationType: 'orders/porting/updateField',
});
export const { mapFields: mapTermsConditionsFields } = createHelpers({
  getterType: `orders/termsConditions/getField`,
  mutationType: `orders/termsConditions/updateField`,
});

export const {
  mapMultiRowFields: mapTermsConditionsMultiRowFields,
} = createHelpers({
  getterType: 'orders/termsConditions/getField',
  mutationType: 'orders/termsConditions/updateField',
});

export const { mapFields: mapRatePlanFields } = createHelpers({
  getterType: `orders/ratePlan/getField`,
  mutationType: `orders/ratePlan/updateField`,
});

export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `orders/auth/getField`,
  mutationType: `orders/auth/updateField`,
});

export const { mapFields: mapDealerFields } = createHelpers({
  getterType: `orders/dealer/getField`,
  mutationType: `orders/dealer/updateField`,
});

export const { mapFields: mapEmployeeFields } = createHelpers({
  getterType: `orders/employee/getField`,
  mutationType: `orders/employee/updateField`,
});

export const { mapFields: mapCompanyFields } = createHelpers({
  getterType: `orders/company/getField`,
  mutationType: `orders/company/updateField`,
});

export const { mapFields: mapCustomerFields } = createHelpers({
  getterType: `orders/customer/getField`,
  mutationType: `orders/customer/updateField`,
});

export const { mapMultiRowFields: mapCustomerMultiRowFields } = createHelpers({
  getterType: 'orders/customer/getField',
  mutationType: 'orders/customer/updateField',
});

export const { mapFields: mapNewChurnFields } = createHelpers({
  getterType: `orders/newChurn/getField`,
  mutationType: `orders/newChurn/updateField`,
});

export const { mapMultiRowFields: mapNewChurnMultiRowFields } = createHelpers({
  getterType: 'orders/newChurn/getField',
  mutationType: 'orders/newChurn/updateField',
});

export const { mapFields: mapLandlineFields } = createHelpers({
  getterType: `orders/landline/getField`,
  mutationType: `orders/landline/updateField`,
});

export const { mapMultiRowFields: mapLandlineMultiRowFields } = createHelpers({
  getterType: 'orders/landline/getField',
  mutationType: 'orders/landline/updateField',
});

export const { mapFields: mapAddressFields } = createHelpers({
  getterType: `orders/address/getField`,
  mutationType: `orders/address/updateField`,
});
export const { mapMultiRowFields: mapAddressMultiRowFields } = createHelpers({
  getterType: 'orders/address/getField',
  mutationType: 'orders/address/updateField',
});

export const { mapMultiRowFields: mapRatePlanMultiRowFields } = createHelpers({
  getterType: 'orders/ratePlan/getField',
  mutationType: 'orders/ratePlan/updateField',
});
export const { mapFields: mapSummaryFields } = createHelpers({
  getterType: `orders/summary/getField`,
  mutationType: `orders/summary/updateField`,
});
export const { mapMultiRowFields: mapNewISDNMultiRowFields } = createHelpers({
  getterType: `orders/isdn/getField`,
  mutationType: `orders/isdn/updateField`,
});

export const { mapFields: mapNewISDNFields } = createHelpers({
  getterType: `orders/isdn/getField`,
  mutationType: `orders/isdn/updateField`,
});

export const { mapFields: mapNewPSTNFields } = createHelpers({
  getterType: `orders/pstn/getField`,
  mutationType: `orders/pstn/updateField`,
});

export const { mapMultiRowFields: mapNewPSTNMultiRowFields } = createHelpers({
  getterType: 'orders/pstn/getField',
  mutationType: 'orders/pstn/updateField',
});

export const { mapFields: mapIPVoiceFields } = createHelpers({
  getterType: `orders/ipVoice/getField`,
  mutationType: `orders/ipVoice/updateField`,
});

export const { mapMultiRowFields: mapIPVoiceMultiRowFields } = createHelpers({
  getterType: 'orders/ipVoice/getField',
  mutationType: 'orders/ipVoice/updateField',
});

export const { mapFields: mapNoteFields } = createHelpers({
  getterType: `orders/notes/getField`,
  mutationType: `orders/notes/updateField`,
});

export const { mapMultiRowFields: mapNoteMultiRowFields } = createHelpers({
  getterType: 'orders/notes/getField',
  mutationType: 'orders/notes/updateField',
});

export const { mapMultiRowFields: mapDealerMultiRowFields } = createHelpers({
  getterType: 'orders/dealer/getField',
  mutationType: 'orders/dealer/updateField',
});

export const { mapMultiRowFields: mapEmployeeMultiRowFields } = createHelpers({
  getterType: 'orders/employee/getField',
  mutationType: 'orders/employee/updateField',
});

export const { mapMultiRowFields: mapInternetMultiRowFields } = createHelpers({
  getterType: 'orders/internet/getField',
  mutationType: 'orders/internet/updateField',
});

export const { mapMultiRowFields: mapHardwareMultiRowFields } = createHelpers({
  getterType: 'orders/hardware/getField',
  mutationType: 'orders/hardware/updateField',
});

export const { mapFields: mapHardwareFields } = createHelpers({
  getterType: `orders/hardware/getField`,
  mutationType: `orders/hardware/updateField`,
});

export const { mapFields: mapInternetFields } = createHelpers({
  getterType: `orders/internet/getField`,
  mutationType: `orders/internet/updateField`,
});

//handset
export const { mapMultiRowFields: mapHandsetMultiRowFields } = createHelpers({
  getterType: 'orders/handset/getField',
  mutationType: 'orders/handset/updateField',
});

export const { mapFields: mapHandsetFields } = createHelpers({
  getterType: `orders/handset/getField`,
  mutationType: `orders/handset/updateField`,
});
export const { mapFields: mapFinanceApplicationFields } = createHelpers({
  getterType: `orders/financeApplication/getField`,
  mutationType: `orders/financeApplication/updateField`,
});
export const { mapFields: mapFeatureFlagFields } = createHelpers({
  getterType: `orders/featureFlag/getField`,
  mutationType: `orders/featureFlag/updateField`,
});
export const {
  mapMultiRowFields: mapFeatureFlagMultiRowFields,
} = createHelpers({
  getterType: 'orders/featureFlag/getField',
  mutationType: 'orders/featureFlag/updateField',
});

export const { mapMultiRowFields: mapCommTargetsRowFields } = createHelpers({
  getterType: 'orders/commissionTargets/getField',
  mutationType: 'orders/commissionTargets/updateField',
});

export const { mapFields: mapCommTargetsMultiRowFields } = createHelpers({
  getterType: `orders/commissionTargets/getField`,
  mutationType: `orders/commissionTargets/updateField`,
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
